export const formatShortId = (id) => {
  if (id === null || id === undefined) {
    return '-';
  }

  const normalized = String(id).trim();
  if (!normalized) {
    return '-';
  }

  return normalized.slice(0, 8);
};

export default formatShortId;
